export default __webpack_public_path__ + "static/media/book-stack.86e390dd.png";